.root {
  position: relative;
  display: flex;
  flex: 1;
}

.root .MuiButtonGroup-root {
  flex: 1;
}

.root .self {
  flex: 1;
}
